/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4u123 = A4u123;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4u123(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M27.517,17.128c-.122,0-.17-.049-.17-.171V14.541c0-.146,0-.244.146-.244l1.217-.011c1.709,0,2.636-.512,2.636-1.635,0-1.074-.9-1.782-2.685-1.782a7.513,7.513,0,0,0-3.612.928c-.146.073-.17,0-.17-.1V9.283c0-.147-.025-.2.122-.269a9.02,9.02,0,0,1,4.246-.951c3.222,0,5.223,1.61,5.223,4.149a3.459,3.459,0,0,1-2.148,3.2,3.877,3.877,0,0,1,2.9,3.807c0,3.125-2.88,4.784-6.248,4.784a8.8,8.8,0,0,1-4.174-.806c-.146-.048-.146-.194-.146-.316V20.241c0-.1.122-.146.22-.1a8.336,8.336,0,0,0,3.978,1.025c2.2,0,3.051-.9,3.051-2.05,0-1.294-.928-2-2.954-2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M4.616,11.27a20.7,20.7,0,0,1-2.582.67c-.167.024-.215-.024-.215-.168V9.69c0-.119.024-.191.167-.215a15.37,15.37,0,0,0,3.092-1.22.884.884,0,0,1,.407-.12H7.838c.12,0,.144.072.144.167L7.976,21.115h2.14c.167,0,.215.072.239.216l.006,2.406c.024.191-.048.263-.191.263H2.327c-.167,0-.215-.072-.191-.215L2.13,21.331a.229.229,0,0,1,.263-.216H4.611Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M12.014,24c-.168,0-.192-.072-.192-.215V22.062a.34.34,0,0,1,.12-.311,58.939,58.939,0,0,0,4.5-4.045c1.89-1.842,2.713-3.033,2.713-4.373,0-1.507-1.23-2.39-3.048-2.39A8.593,8.593,0,0,0,12.253,12c-.144.072-.239.024-.239-.143V9.484a.271.271,0,0,1,.143-.287A9.108,9.108,0,0,1,16.9,8c3.518,0,5.183,2.1,5.332,4.771.12,2.163-.869,3.809-2.472,5.46A37.052,37.052,0,0,1,16.72,21.16c1.652,0,5.053-.045,6.465-.045.168,0,.191.048.168.216l-.714,2.478a.238.238,0,0,1-.264.191Z"
  }));
}